<template>
  <div class="card">
    <div class="d-flex my-10">
      <div class="d-flex align-center mr-6">
        <v-img
          class="bus-icon"
          :src="require('../../../../assets/pc/index/prodCore/产品业务结构icon.png')"
          :lazy-src="require('../../../../assets/pc/index/prodCore/产品业务结构icon.png')"
        ></v-img>
      </div>
      <div class="font-big">产品业务结构</div>
    </div>
    <div>
      <!--业务层-->
      <div class="d-flex flex-column my-5 outer-box justify-center">
        <div class="ma-5 font-nor">业务层</div>
        <div class="line d-flex justify-space-around pa-2">
          <div v-for="(item,key) in bus" :key="item">
            <div class="bus-img d-flex justify-center align-center">
              <div :class="`bus${key}`"></div>
            </div>
            <div class="bus-text d-flex justify-center align-center">
              <div class="font-nor" :style="{width: key === 4 ? '80px' : '70px'}">
                {{ item }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--应用层-->
      <div class="d-flex flex-column my-5 outer-box justify-center">
        <div class="ma-5 font-nor">应用层</div>
        <div class="d-flex py-4">
          <div v-for="item in app" :key="item.name" class="d-flex align-center mx-2">
            <div style="width: 10%;" class="ml-1 font-sml text-center"> {{ item.name }}</div>
            <div style="width: 90%" class="d-flex justify-space-around align-center flex-wrap mr-3">
              <div v-for="val in item.array" class="app-inner d-flex justify-center align-center my-1 mx-1" :key="val">{{ val }}</div>
            </div>
          </div>
        </div>
      </div>
      <!--数据管理-->
      <div class="d-flex flex-column my-5 outer-box justify-center">
        <div class="ma-5 font-nor">数据管理</div>
        <div class="line d-flex justify-space-around pa-2">
          <div v-for="(item,key) in dataMana" :key="item">
            <div class="bus-img d-flex justify-center align-center">
              <div :class="`dataMana${key}`"></div>
            </div>
            <div class="bus-text d-flex justify-center align-center">
              <div class="font-sml">
                {{ item }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--OCR+结构化-->
      <div class="d-flex justify-space-around align-center px-2">
        <div class="up-arrow ml-7"></div>
        <div style="font-weight: 400;font-size: 16px"> OCR识别+结构化导入</div>
        <div class="up-arrow mr-7"></div>
      </div>
      <!--数据源-->
      <div class="d-flex flex-column my-5 outer-box justify-center">
        <div class="ma-5 font-nor">数据源</div>
        <div class="line d-flex justify-space-around pa-2">
          <div v-for="(item,key) in dataOri" :key="item">
            <div class="bus-img d-flex justify-center align-center">
              <div :class="`dataOri${key}`"></div>
            </div>
            <div class="bus-text d-flex justify-center align-center">
              <div class="font-sml">
                {{ item }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'busArchi',
  data () {
    return {
      bus: ['智能问答', '智能客服', '智能销售与推荐', '智能临床辅助决策', '智能风控反欺诈引擎', '智能动态配置资源'],
      app: [{
        name: '项目管理',
        array: ['知识库管理', '人员管理', '文件管理', '元数据配置']
      }, {
        name: '模板配置',
        array: ['模板定义', '规则配置', '输入配置', '应用配置']
      }, {
        name: '生成应用',
        array: ['分析解读', '电子档案', '患者管理', '病程管理']
      }, {
        name: '知识标注',
        array: ['人工标注', '预标注']
      }, {
        name: '知识审核',
        array: ['标注审核', '驳回审核']
      }],
      dataMana: ['结构化', '半结构化', '非结构化'],
      dataOri: ['资源库', 'pdf', '文档', '表格', '图片']
    }
  }
}
</script>

<style scoped>
.card {
  max-width: 1200px;
  margin: auto;
}

.outer-box {
  width: 100%;
  height: 310px;
  background: #F7F7F7;
}

.bus-icon {
  height: 8px;
}

.bus0 {
  background: url('../../../../assets/pc/index/prodCore/产品业务架构.png') no-repeat -169px -26px;
  width: 75px;
  height: 77px;
}

.bus1 {
  background: url('../../../../assets/pc/index/prodCore/产品业务架构.png') no-repeat -337px -31px;
  width: 80px;
  height: 64px;
}

.bus2 {
  background: url('../../../../assets/pc/index/prodCore/产品业务架构.png') no-repeat -518px -24px;
  width: 85px;
  height: 79px;
}

.bus3 {
  background: url('../../../../assets/pc/index/prodCore/产品业务架构.png') no-repeat -709px -38px;
  width: 70px;
  height: 58px;
}

.bus4 {
  background: url('../../../../assets/pc/index/prodCore/产品业务架构.png') no-repeat -870px -34px;
  width: 98px;
  height: 78px;
}

.bus5 {
  background: url('../../../../assets/pc/index/prodCore/产品业务架构.png') no-repeat -1047px -19px;
  width: 105px;
  height: 94px;
}

.bus-img {
  width: 110px;
  height: 110px;
}

.bus-text {
  width: 110px;
  text-align: center;
}

.app-inner {
  background: #2f81f6;
  color: #fff;
  width: 100px;
  height: 50px;
  text-align: center;
  padding: 6px 3px;
  margin: 2px;
  font-size: 14px;
  font-weight: 400;
}

.dataMana0 {
  background: url('../../../../assets/pc/index/prodCore/产品业务架构.png') no-repeat -269px -370px;
  width: 46px;
  height: 51px;
}

.dataMana1 {
  background: url('../../../../assets/pc/index/prodCore/产品业务架构.png') no-repeat -634px -370px;
  width: 39px;
  height: 50px;
}

.dataMana2 {
  background: url('../../../../assets/pc/index/prodCore/产品业务架构.png') no-repeat -994px -370px;
  width: 43px;
  height: 50px;
}

.dataOri0 {
  background: url('../../../../assets/pc/index/prodCore/产品业务架构.png') no-repeat -267px -529px;
  width: 51px;
  height: 42px;
}

.up-arrow {
  background: url('../../../../assets/pc/index/prodCore/产品业务架构.png') no-repeat -281px -475px;
  width: 28px;
  height: 36px;
}

.dataOri1 {
  background: url('../../../../assets/pc/index/prodCore/产品业务架构.png') no-repeat -461px -530px;
  width: 31px;
  height: 39px;
}

.dataOri2 {
  background: url('../../../../assets/pc/index/prodCore/产品业务架构.png') no-repeat -629px -524px;
  width: 51px;
  height: 51px;
}

.dataOri3 {
  background: url('../../../../assets/pc/index/prodCore/产品业务架构.png') no-repeat -810px -524px;
  width: 51px;
  height: 51px;
}

.dataOri4 {
  background: url('../../../../assets/pc/index/prodCore/产品业务架构.png') no-repeat -996px -524px;
  width: 38px;
  height: 51px;
}

.font-big {
  font-size: 20px;
  font-weight: 400;
}

.font-nor {
  font-size: 16px;
  font-weight: 400;
}

.font-sml {
  font-size: 14px;
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/pc/home/prodCore/busArchi.vue